var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStorySocialLove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7607B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DF1630"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "url(#a)",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.504 14.4c1.797-4.613 7.838-3.52 9.406-2.515q1.568 1.006 2.09 3.018.522-2.011 2.09-3.018c1.568-1.006 7.839-2.012 9.406 2.515s-.522 9.055-6.278 13.079L20 31l-5.228-3.521C9.027 23.455 6.936 18.424 8.504 14.4"
}))));
export default SvgFacebookMobileStorySocialLove;